module.exports = __webpack_public_path__ + "img/avatar-1.f5ab4813.jpg";